import { css } from "@emotion/react";
import React, { useContext } from "react";
import dayjs from "dayjs";
import { useTheme } from "../theme";
import { LocaleContext } from "../LocaleProvider";

export interface CalendarWeekProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: never;
  format?: "narrow" | "short" | "long";
}

const START_OF_WEEK = dayjs().startOf("week");
const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6].map((elapsed) =>
  START_OF_WEEK.add(elapsed, "day").toDate(),
);

const sx = {
  container: css`
    display: flex;
    min-width: 294px;
  `,
  weekday: css`
    box-sizing: border-box;
    display: flex;
    flex: 1;
    justify-content: center;
    width: 100%;
    text-align: right;
  `,
};

export const CalendarWeek = React.memo(
  ({ format = "short", ...others }: CalendarWeekProps) => {
    const locale = useContext(LocaleContext);
    const theme = useTheme();
    return (
      <div {...others} css={sx.container}>
        {WEEKDAYS.map((date, index) => {
          const weekday = date.toLocaleDateString(locale, {
            weekday: format,
          });
          return (
            <div key={index} css={[sx.weekday, theme.typography.body]}>
              {weekday}
            </div>
          );
        })}
      </div>
    );
  },
  () => true,
);
